import { defineComponent, toRef, createElementBlock, openBlock, toDisplayString, unref } from "vue";
import { u as useFormatDateTime } from "./useFormatDateTime-lk3QDXbQ.mjs";
const _hoisted_1 = ["data-timestamp", "title", "textContent"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NcDateTime",
  props: {
    timestamp: {},
    format: { default: () => ({ timeStyle: "medium", dateStyle: "short" }) },
    relativeTime: { type: [Boolean, String], default: "long" },
    ignoreSeconds: { type: Boolean }
  },
  setup(__props) {
    const props = __props;
    const {
      formattedTime,
      formattedFullTime
    } = useFormatDateTime(toRef(() => props.timestamp), props);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("span", {
        class: "nc-datetime",
        "data-timestamp": _ctx.timestamp,
        title: unref(formattedFullTime),
        textContent: toDisplayString(unref(formattedTime))
      }, null, 8, _hoisted_1);
    };
  }
});
export {
  _sfc_main as _
};
//# sourceMappingURL=NcDateTime.vue_vue_type_script_setup_true_lang-CKX0mNnP.mjs.map
